import { Add, Edit } from "@mui/icons-material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";
import { GridCellParams, GridColDef } from "@mui/x-data-grid-premium";
import { DiscountProfile } from "@repo/server-api";
import { useTranslation } from "next-i18next";
import { useMemo, useState } from "react";

import { useAllDisountProfilesDataSource } from "@repo/legacy/components/shared/datasources/AllDiscountProfilesDataSource";
import ConformationDialog from "@repo/legacy/components/shared/dialogs/Conformation";
import DialogDiscountProfile from "@repo/legacy/components/shared/dialogs/DialogDiscountProfile";
import List from "@repo/legacy/components/shared/lists/List";

const DiscountProfiles = () => {
	const { t } = useTranslation();

	const [profile, setProfile] = useState<DiscountProfile>({
		id: "",
		maxDueDate: 0,
		entries: [],
		name: "",
		version: 0,
		isDeleted: false,
	});
	const [openDialog, setOpenDialog] = useState<boolean>(false);

	const allDiscountProfileDataSource = useAllDisountProfilesDataSource();

	const columns: GridColDef<DiscountProfile>[] = useMemo(
		() => [
			{
				field: "name",
				headerName: t("name"),
				flex: 1,
				minWidth: 150,
				renderCell(params: GridCellParams) {
					return params.row.name;
				},
			},
			{
				field: "actions",
				headerName: t("actions"),
				sortable: false,
				width: 150,
				renderCell: (params: GridCellParams) => {
					const [openDeleteConformation, setOpenDeleteConformation] = useState<boolean>(false);

					const handleYes = (id: string) => {
						if (allDiscountProfileDataSource.deleteData)
							allDiscountProfileDataSource.deleteData(id);
						setOpenDeleteConformation(false);
					};
					const openDelete = () => {
						setOpenDeleteConformation(true);
					};
					const openEdit = (profile: DiscountProfile) => {
						setProfile(profile);
						setOpenDialog(true);
					};

					return (
						<div>
							<Button data-testid="edit-button" onClick={() => openEdit(params.row)}>
								<Edit />
							</Button>
							<Button data-testid="delete-button" onClick={() => openDelete()}>
								<DeleteIcon />
							</Button>
							<ConformationDialog
								text={t("profiles.deleteConformation")}
								setOpenDeleteConformation={setOpenDeleteConformation}
								openPopup={openDeleteConformation}
								handleYes={() => handleYes(params.id.toString())}
							/>
						</div>
					);
				},
			},
		],

		[t],
	);

	return (
		<>
			<DialogDiscountProfile
				refreshData={allDiscountProfileDataSource.refresh ?? (() => {})}
				setOpen={setOpenDialog}
				open={openDialog}
				profile={profile}
			/>
			<h3 className="purpleHeader">{t("discount-profiles")}</h3>
			<List
				columns={columns as GridCellParams<DiscountProfile>[]}
				dataSource={allDiscountProfileDataSource}>
				<Button
					className="blueButton right"
					color="secondary"
					variant="contained"
					data-testid="create-discount-profile-button"
					onClick={() => {
						setProfile({
							id: "",
							maxDueDate: 0,
							entries: [],
							name: "",
							version: 0,
							isDeleted: false,
						});
						setOpenDialog(true);
					}}>
					{t("create-discount-profile")} <Add />
				</Button>
			</List>
		</>
	);
};

export default DiscountProfiles;
